import React, { useEffect, useState } from "react";
import Modal from 'react-modal';
import Flex from '@react-css/flex';
import Swal from "sweetalert2";
import api from '../../services/api';
import { StyledForm } from "../../styled-components/StyledForm.style";
import { useLocation } from "react-router-dom";

export const ModalTimeSheetExportarPDF = ({
    isOpen,
    setIsOpen,
    onExportar ,
    indicacao,
    pendenciaDeAprovacao
}) => {
    const [isLoading, setisLoading] = useState(false);
    const [isLoadingPreview, setIsLoadingPreview] = useState(false);
    const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null);
    let location = useLocation();
    
    // --- ESPAÇO PARA FUTUROS PARÂMETROS ---
    // Exemplo:
    // const [formato, setFormato] = useState('XLSX');
    // const [comentarios, setComentarios] = useState(false);

    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '50%',
            overflowY: 'auto',
            minHeight: '45%',
            maxHeight: '90%'
        },
        overlay: {
            zIndex: 9999
        }
    };

    const onAfterOpen = () => { };
    const closeModal = () => { 
        if (pdfPreviewUrl) {
            window.URL.revokeObjectURL(pdfPreviewUrl);
            setPdfPreviewUrl(null);
        }
        setisLoading(false);
        setIsOpen(false); 
    }

    const onClickAction = (tipo) => {
        Swal.fire({
            html: `Deseja Exportar o Relatório?`, 
            icon: "info",
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
        }).then(async (result) => {
            if (result.isConfirmed) {
                setisLoading(true);
                Swal.showLoading();
                
                try {
                    // --- COLETA DE PARÂMETROS FUTUROS ---
                    const parametrosDoModal = {
                        // Formato: formato,
                        // IncluirComentarios: comentarios
                        // Adicione aqui qualquer dado que o usuário preencher neste modal
                    };
                    
                    await onExportar(parametrosDoModal, tipo);

                    setisLoading(false);
                    setIsOpen(false);
                    Swal.close(); 
                    
                } catch (err) {
                    console.error(err); 
                    setisLoading(false);
                }
            } else {
                setisLoading(false);
            }
        });
    };

    useEffect(() => {
        let isMounted = true;

        const carregarPreview = async () => {
            if (!isOpen) return;

            setIsLoadingPreview(true);
            if (pdfPreviewUrl) {
                window.URL.revokeObjectURL(pdfPreviewUrl);
                setPdfPreviewUrl(null);
            }

            try {
                console.log("indicacao", indicacao);
                console.log("pendenciaDeAprovacao", pendenciaDeAprovacao);


                const tipoPreview = indicacao ? "vinculado" : "normal";

                let idTimesheet = location.hash.replace("#", '');
                if (pendenciaDeAprovacao) {
                    idTimesheet = pendenciaDeAprovacao.idTimesheet;
                }
                const response = await api.get(`Timesheet/timesheet-exportar-pdf/${tipoPreview}/${idTimesheet}`, {
                    responseType: 'blob'
                });

                if (isMounted) {
                    const fileBlob = new Blob([response.data], { type: 'application/pdf' });
                    const url = window.URL.createObjectURL(fileBlob);
                    setPdfPreviewUrl(url);
                }
            } catch (error) {
                console.error("Erro ao carregar preview do PDF", error);
            } finally {
                if (isMounted) {
                    setIsLoadingPreview(false);
                }
            }
        };

        carregarPreview();

        return () => {
            isMounted = false;
        };
    }, [isOpen, indicacao]);

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={closeModal}
            contentLabel="Modal Exportar"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledForm>
                <Flex>
                    <Flex.Item className="modal-width">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="pull-left">
                                <p className="modal-title">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="28" height="28" className="me-2">
                                            <path fill={'#999'} d="M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 242.7 256 32zM64 320c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-46.9 0-56.6 56.6c-31.2 31.2-81.9 31.2-113.1 0L110.9 320 64 320zm304 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"/></svg>                                    
                                    Exportar</p>
                            </div>
                            <div className="pull-right">
                                <p className="modal-close" onClick={closeModal}><button className="default-button-red-small px-2">X</button></p>
                            </div>
                        </div>
                    </Flex.Item>
                </Flex>
                
                {/* --- ESPAÇO PARA INPUTS FUTUROS --- */}
                {/* <div className="row"> 
                       <div className="col">
                           Seus inputs de configuração de exportação virão aqui 
                       </div>
                    </div> 
                */}

                { isLoading ? 
                (
                <div className="text-center">
                    <div className="text-items-center">
                        <div className="spinner-border ms-auto mt-2" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                        <div className="mt-2">
                            <strong style={{ color: "#EE4B21" }}>Gerando PDF, por favor aguarde...</strong>
                        </div>
                    </div>
                </div>
                ) : (
                    <>
                    <div className="modal-divider" style={ { opacity: "0.3" }}><hr /></div>
                    
                    <div className="my-3 text-center" style={{ width: '100%', height: '400px' }}>
                        {isLoadingPreview ? (
                            <div className="d-flex justify-content-center align-items-center h-100">
                                <div className="spinner-border" style={{ color: "#EE4B21" }} role="status"></div>
                                <span className="ms-2">Carregando preview...</span>
                            </div>
                        ) : pdfPreviewUrl ? (
                            <iframe 
                                src={`${pdfPreviewUrl}#toolbar=0&navpanes=0`} 
                                title="Preview PDF" 
                                width="100%" 
                                height="100%" 
                                style={{ border: '1px solid #ddd' }}
                            />
                        ) : (
                            <span className="text-muted">Não foi possível carregar o preview.</span>
                        )}
                    </div>

                    <div className="modal-divider" style={ { opacity: "0.3" }}><hr /></div>

                    <Flex>
                        <Flex.Item>
                            <div className="row align-items-center justify-content-center">
                                <div className="col text-center">
                                    <input 
                                            className='default-button-red' 
                                            value={'Exportar'} 
                                            type="button" 
                                            onClick={onClickAction.bind(null, "normal")}/>
                                </div>

                                {indicacao && (
                                    <div className="col text-center">
                                        <input 
                                                className='default-button-red' 
                                                value={'Exportar Vinculado'} 
                                                type="button" 
                                                onClick={onClickAction.bind(null, "vinculado")}/>
                                    </div>
                                )}
                            </div>
                        </Flex.Item>
                    </Flex>
                    </>
                )}
            </StyledForm>
        </Modal>
    );
};